export function isJsonString(str) {
  try {
    if (typeof JSON.parse(str) == 'object') {
      return true;
    }
  } catch (e) {
    console.log('这个不是有效json', e);
  }
  return false;
}

export function to(promise, errorExt) {
  return promise
    .then((data) => [null, data])
    .catch((err) => {
      if (errorExt) {
        const parsedError = Object.assign({}, err, errorExt);
        return [parsedError, undefined];
      }
      return [err, undefined];
    });
}

/**
 * 格式化输入金额为千分位格式，并保留小数部分
 * @param {string} value - 原始输入值，可能包含整数部分和小数部分
 * @returns {string} - 格式化后的金额字符串
 */
export function formatAmount(value) {
  if (!value) return ''; // 空值直接返回
  const [integerPart, decimalPart] = value.split('.'); // 分离整数和小数部分
  const formattedInteger = Number(integerPart).toLocaleString(); // 整数部分加千分位
  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}` // 组合整数和小数部分
    : formattedInteger; // 仅返回整数部分
}

export function getPageCode(accountBankCode, bankCode) {
  const a = accountBankCode === bankCode;
  const type = {
    momo: 'momo_from_admin',
    vtp: 'vtp_from_admin',
    SEAB: 'seaBank',
    TCB: 'TCBbank',
    BIDV: 'BIDV',
    VPB: 'VPBank',
    SHB: 'SHB-S',
    VIB: a ? 'VIB-s' : 'VIB',
    MSB: a ? 'MSB-S' : 'MSB',
    VTB: 'VTBbank',
    VCB: a ? 'VCB-S' : 'VCB',
    EXB: 'EXB',
    NAMABA: 'NAMABA',
    SAC: a ? 'SAC-S' : 'SAC',
    OCB: a ? 'OCB-S' : 'OCB',
    NCB: a ? 'NCB-S' : 'NCB'
  };
  // 定义各页面对应的默认宽度和高度
  const dimensions = {
    VPBank: { width: 390, height: 850 },
    seaBank: { width: 390, height: 812 },
    TCBbank: { width: 390, height: 812 },
    momo_from_admin: { width: 375, height: 800 },
    MSB: { width: 370, height: 850 },
    'MSB-S': { width: 370, height: 850 },
    VTBbank: { width: 395, height: 690 },
    'SHB-S': { width: 303, height: 630 },
    NAMABA: { width: 414, height: 870 },
    'SAC-S': { width: 414, height: 870 },
    SAC: { width: 414, height: 900 },
    'OCB-S': { width: 414, height: 917 },
    OCB: { width: 414, height: 917 },
    'NCB-S': { width: 414, height: 920 },
    NCB: { width: 414, height: 920 }
  };
  const page = type[accountBankCode];

  return {
    page,
    width: (dimensions[page] && dimensions[page].width) || 375,
    height: (dimensions[page] && dimensions[page].height) || 812
  };
}

export function openCenteredWindow({
  pageCode,
  data,
  width = 375,
  height = 812,
  name = 'subWind',
  bankCode
}) {
  const config = {
    width,
    height,
    left() {
      return parseInt(screen.availWidth / 2 - this.width / 2);
    }, // 屏幕居中
    top() {
      return parseInt(screen.availHeight / 2 - this.height / 2);
    }
  };

  // 拼接完整 URL
  const fullUrl = `https://vippay.vippay888.com/${pageCode}.html?data=${encodeURIComponent(
    data
  )}${`&bankCode=${bankCode}`}`;

  // 打开新窗口
  window.open(
    fullUrl,
    name,
    `width=${config.width},height=${
      config.height
    },status,resizable,left=${config.left()},top=${config.top()},screenX=${config.left()},screenY=${config.top()}`
  );
}

export function removeCommas(value) {
  if (!value) return '';
  return value.replace(/,/g, '');
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

export function delimiterAmount(n) {
  if (!n || typeof n == 'undefined') return;
  n = String(n);
  let str = n.split('.');
  let re = /\d{1,3}(?=(\d{3})+$)/g;
  let n1 = str[0].replace(re, '$&,');
  return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}`;
}



// WEBPACK FOOTER //
// ./src/utils/index.js